<template>
  <div>
    <template v-for="menu in menuList">
      <!-- 如果当前有子菜单，则显示 el-submenu ，在el-subment 里调用 递归组件 -->
      <el-submenu
        v-if="menu.children && menu.children.length > 0"
        :index="menu.id"
      >
        <template slot="title">
          <i :class="menu.icon"></i>
          <span slot="title" :style="collapse ? 'display: none' : ''">{{ menu.name }}</span>
        </template>
        <!-- 调用自身 -->
        <MenuTree :menuList="menu.children"></MenuTree>
      </el-submenu>
      <!-- 如果没有子菜单，则显示当前内容 -->
      <el-menu-item v-else :index="menu.id" @click="routeTo(menu.path)">
        <i :class="menu.icon"></i>
        <span slot="title">{{ menu.name }}</span>
      </el-menu-item>
    </template>
  </div>
</template>

<script>
import menuTree from "./menuTree.vue";
export default {
  name: "MenuTree",
  components: {
    menuTree
  },
  props: {
    menuList: {
      type: Array
    },
    collapse: {
      type: Boolean
    }
  },
  data () {
    return {

    };
  },
  mounted () {
  },
  methods: {
    routeTo(url) {
      if(this.$route.path !== url) {
        this.$router.push(url);
      }
    },
  }
}
</script>

<style scoped>

</style>
